import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NewsletterConfirm.css';

const NewsletterConfirm = () => {
  const { token } = useParams();
  const [status, setStatus] = useState({ type: 'loading', message: 'Confirmando tu suscripción...' });

  useEffect(() => {
    const confirmSubscription = async () => {
      try {
        const response = await fetch(`http://localhost:5001/api/newsletter/confirm/${token}`);
        const data = await response.json();

        if (response.ok) {
          setStatus({ type: 'success', message: data.message });
        } else {
          setStatus({ type: 'error', message: data.error });
        }
      } catch (error) {
        console.error('Confirmation error:', error);
        setStatus({ 
          type: 'error', 
          message: 'Error al confirmar la suscripción. Intenta nuevamente más tarde.' 
        });
      }
    };

    if (token) {
      confirmSubscription();
    }
  }, [token]);

  return (
    <div className="newsletter-confirm-page">
      <Helmet>
        <title>Confirmar Newsletter | Graphyra</title>
        <meta name="description" content="Confirmación de suscripción al newsletter de Graphyra" />
      </Helmet>

      <div className="newsletter-confirm-container">
        <div className={`newsletter-confirm-card ${status.type}`}>
          {status.type === 'loading' && (
            <div className="spinner-container">
              <div className="spinner"></div>
            </div>
          )}
          
          {status.type === 'success' && (
            <div className="success-icon">✅</div>
          )}
          
          {status.type === 'error' && (
            <div className="error-icon">❌</div>
          )}

          <h1>{status.type === 'success' ? '¡Confirmación Exitosa!' : status.type === 'error' ? 'Error' : 'Confirmando...'}</h1>
          <p className="status-message">{status.message}</p>

          {status.type === 'success' && (
            <div className="success-content">
              <p>Gracias por unirte a nuestra comunidad. A partir de ahora recibirás:</p>
              <ul className="benefits-list">
                <li>📚 Los mejores artículos científicos y educativos</li>
                <li>🔬 Análisis de tendencias en ciencia y tecnología</li>
                <li>💡 Recursos de aprendizaje curados especialmente</li>
                <li>🎯 Contenido exclusivo para suscriptores</li>
                <li>📰 Noticias y actualizaciones de la plataforma</li>
              </ul>
            </div>
          )}

          <div className="action-buttons">
            <Link to="/" className="primary-button">
              Ir al Inicio
            </Link>
            {status.type === 'success' && (
              <Link to="/explore" className="secondary-button">
                Explorar Contenido
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterConfirm;
